import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isNil, reject } from 'lodash-es';

import { ApplicationAdapter } from 'application/application.adapter';
import { OrganizationOutput } from 'organization/model/organization.output';
import { Organization } from 'organization/organization';
import { OrganizationConverterPort } from 'organization/port/organization-converter.port';
import { OrganizationPropertiesConverterPort } from 'organization/property/port/organization-properties-converter.port';

@Injectable()
export class OrganizationConverterAdapter
	extends ApplicationAdapter
	implements OrganizationConverterPort
{
	constructor(
		translateService: TranslateService,
		private _organizationPropertiesConverterPort: OrganizationPropertiesConverterPort
	) {
		super(translateService);
	}

	public organizationAsEntity(output: OrganizationOutput): Organization {
		if (!output) {
			return null;
		}

		return new Organization(
			output.id,
			output.name,
			output.sectors,
			output.iconUrl,
			output.logoUrl,
			output.description,
			output.style?.primaryColor,
			output.planPrice ?? { amount: 0, currency: 'EUR' },
			output.updateTimestamp,
			output.shortDescription,
			output.sessionPrice ?? {
				amount: 0,
				currency: 'EUR',
			},
			this._organizationPropertiesConverterPort.organizationPropertiesAsEntities(
				output.properties
			),
			output.paymentProviderSubscriptionId
		);
	}

	public organizationsAsEntities(outputs: OrganizationOutput[]): Organization[] {
		return reject(outputs, isNil).map((output) =>
			this.organizationAsEntity(output)
		);
	}
}
